import React from 'react';
import HeaderLogo from './HeaderLogo';
import '../../../src/assets/scss/common/_header.scss';
import LogoImage from '../../assets/images-new/logo.svg';
import Splash from './Splash';
import { APP_DOMAIN } from '../../constants/constants';

const SimpleHeader = (props) => {
    return (<>
        <div className="app-container">
            <header className="header">
                <div className={`header-main`}>
                    <a className="share-screen-logo" href={APP_DOMAIN}>
                        <LogoImage />
                    </a>
                </div>
            </header>
        </div>
       <div className="splash-preview"> {!props.hasOwnProperty('showSplash') ? <Splash /> : ''}</div>
    </>);
}

export default SimpleHeader;